import { getFormattedTime } from '@zorba-shared/core/Services/textService';
import dayjs from 'dayjs';

export const getFriendlyDateRangeString = (dateRange) => {
  if (!Array.isArray(dateRange) || dateRange.length !== 2) {
    return dateRange.map((element) => getFormattedTime(element, 'YYYY-MM-DD'));
  }

  const [startDate, endDate] = dateRange;
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const today = dayjs();

  // Check if the range ends today
  if (end.isSame(today, 'day')) {
    const daysDiff = today.diff(start, 'day');

    // For other ranges ending today, show "Last X days"
    if (daysDiff > 0) return [`Last ${daysDiff} days`];
  }

  // For custom ranges not ending today, show formatted dates
  return [
    `${getFormattedTime(startDate, 'MMM D')} - ${getFormattedTime(
      endDate,
      'MMM D, YYYY',
    )}`,
  ];
};
